<template>
  <article class="metrics-card">
    <header class="metrics-header">
      <h2 class="business-name">{{ name }}</h2>
      <div
          v-if="haveDetail" class="notification-button" role="button" tabindex="0">
        <img
            loading="lazy"
            src="/assets/dashboard_bv_vector.svg"
            class="icon"
            alt=""
        />
      </div>
    </header>

    <section class="metrics-section">
      <div class="metric-row">
        <span class="metric-label">Omzet</span>
        <span class="metric-value">€{{formatNumber(revenue)}}</span>
        <TrendIcon :percentage-change="revenuePercentageChange" :is-trend="revenue>0"/>
      </div>

      <div class="metric-row">
        <span class="metric-label">Kosten</span>
        <span class="metric-value">€{{formatNumber(costs)}}</span>
        <TrendIcon :percentage-change="costsPercentageChange" :is-trend="costs>0"/>
      </div>

      <div class="metric-row">
        <span class="metric-label">Winst/Verlies</span>
        <span class="metric-value">€{{formatNumber(profitLoss)}}</span>
        <TrendIcon :percentage-change="profitPercentageChange" :is-trend="profitLoss>0"/>
      </div>
    </section>
    <div class="button-parent" v-if="haveDetail">
      <button class="details-button">
        <span>Details</span>
        <img
            loading="lazy"
            src="/assets/arrow-right.svg"
            class="icon"
            alt=""
        />
      </button>
    </div>
  </article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TrendIcon from "../../components/icons/TrendIcon.vue";

export default defineComponent({
  name: 'BusinessViewCard',
  components: {TrendIcon},

  props: {
    haveDetail:Boolean,
    name: {
      type: String,
      required: true
    },
    revenue: {
      type: Number,
      required: true
    },
    costs: {
      type: Number,
      required: true
    },
    profitLoss: {
      type: Number,
      required: true
    },
    isTopBV: {
      type: Boolean,
      default: false
    },
    revenuePercentageChange: {
      type: Number,
      required: true
    },
    costsPercentageChange: {
      type: Number,
      required: true
    },
    profitPercentageChange: {
      type: Number,
      required: true
    }
  },

  methods: {
    formatNumber(value: number): string {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },

    handleDetails(): void {
      this.$emit('details-click');
    }
  }
});
</script>

<style scoped>

.button-parent {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}
.metrics-card {
  border-radius: 24px;
  background-color: rgba(247, 248, 252, 1);
  box-shadow: 0 0 22px rgba(94, 94, 94, 0.1);
  display: flex;
  height: 210px;
  width: 100%;
  min-width: 268px;
  max-width: 310px;
  flex-direction: column;
  justify-content: center;
  margin: 4px 0;
  padding: 10px 8px;
}

.metrics-header {
  display: flex;
  padding-bottom: 4px;
  align-items: center;
  gap: 2px;
}

.business-name {
  text-align: start;
  color: var(--Neutral-5, #191a1f);
  flex: 1;
  font: 500 16px Montserrat, sans-serif;
  margin: 0;
}

.notification-button {
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--secondary-light-1, #ffeed6);
  display: flex;
  min-height: 24px;
  width: 32px;
  padding: 4px 8px;
  cursor: pointer;
}

.icon {
  aspect-ratio: 1;
  object-fit: contain;
  width: 16px;
}

.metrics-section {
  margin-top: 16px;
}

.metric-row {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 4px;
  color: var(--Neutral-5, #191a1f);
  white-space: nowrap;
  font: 500 10px/1.6 Montserrat, sans-serif;
  margin-bottom: 16px;
}

.metric-label {
  flex: 1;
  text-align: start;
}

.metric-value {
  font-size: 16px;
}

.metric-change {
  display: flex;
  align-items: center;
}

.metric-change.positive {
  color: var(--green-4, #35aa09);
}

.details-button {
  width: 100px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--Primary-Primary, #080aed);
  border: none;
  display: flex;
  min-height: 24px;
  gap: 4px;
  color: var(--Neutral-1, #fcfcfc);
  padding: 4px 24px;
  font: 500 12px/1 Montserrat, sans-serif;
  cursor: pointer;
}

@media (max-width: 991px) {
  .metric-row {
    white-space: initial;
  }

  .details-button {
    padding: 4px 20px;
  }
}
</style>